import { Popover } from 'antd'
import type { PopoverProps } from 'antd'

/**
 * Canonical anchored popover for small action panels (status pickers,
 * quick options) opened from icon buttons.
 */
export default function VistoeraActionPopover({ arrow, overlayClassName, ...rest }: PopoverProps) {
  const mergedArrow =
    arrow === false ? false : { pointAtCenter: true, ...(arrow && typeof arrow === 'object' ? arrow : {}) }
  return (
    <Popover
      {...rest}
      arrow={mergedArrow}
      overlayClassName={['vistoera-action-popover-overlay', overlayClassName].filter(Boolean).join(' ')}
    />
  )
}
